// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1425j","header":"Messages_header__FlY_9"};